import React, { useState } from "react";
import { Button, Row, Col, Space } from "antd";
import styles from "./QCReview.module.css";
import NewExtensionOfStayFormEchs from "./NewExtensionOfStayFormEchs";
import { Form } from "antd";
import RightSideFilePreview from "./RightSideFilePreview";
import uploadStyles from "./UploadJustification.module.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";

interface IQCReviewProps {
  onNext?: () => void;
  onCancel?: () => void;
  caseInfo?: {
    caseId?: string;
    patientName?: string;
  };
  documentPath?: string;
  form: any;
  uploadedDocuments?: any;
  documentTypes?: any;
  activeKey: any;
  setUploadedDocuments: any;
  groupDocumentsByType?: any;
  handleSubmit: any;
  isProcedureSubmitted: boolean;
  isSaving: boolean;
  isSubmitting: boolean;
}

const QCReviewExtensionOfStay: React.FC<IQCReviewProps> = ({
  onNext,
  onCancel,
  caseInfo,
  documentPath = "justification_letter_v2.pdf",
  form,
  uploadedDocuments,
  documentTypes,
  activeKey,
  setUploadedDocuments,
  groupDocumentsByType,
  handleSubmit,
  isProcedureSubmitted,
  isSaving,
  isSubmitting,
}) => {
  const { auth } = useSelector((state: RootState) => state);
  const availableDocumentTypes = React.useMemo(
    () =>
      documentTypes?.filter((docType: any) =>
        docType?.label
          ?.toLowerCase()
          ?.includes("justification") ||
        docType?.label?.toLowerCase()?.includes("geo-tagged"),
      ),
    [documentTypes],
  );
  const [selectedDocTypeId, setSelectedDocTypeId] = useState<any>(null);

  React.useEffect(() => {
    if (
      selectedDocTypeId == null &&
      availableDocumentTypes?.length > 0
    ) {
      setSelectedDocTypeId(
        availableDocumentTypes[0]?.labelId ?? availableDocumentTypes[0]?.label,
      );
    }
  }, [availableDocumentTypes, selectedDocTypeId]);

  const selectedDocType = availableDocumentTypes?.find((docType: any) =>
    docType?.labelId === selectedDocTypeId || docType?.label === selectedDocTypeId,
  );

  const selectedDocuments = uploadedDocuments?.filter((doc: any) =>
    doc?.documentType === selectedDocType?.labelId ||
    doc?.documentLabelType === selectedDocType?.label,
  );

  return (
    <div className={styles.qcReviewContent}>
      {/* <div className={styles.qcReviewHeader}>
        <p className={styles.qcReviewSubtitle}>
          {caseInfo.caseId} • PATIENT: {caseInfo.patientName}
        </p>
      </div> */}

      <Row gutter={[16, 16]} style={{ height: "90vh" }}>
        <Col xs={24} sm={24} md={14}>
          <div className={uploadStyles.uploadJustificationSection}>
            <div className={uploadStyles.uploadJustificationLabel}>
              {selectedDocType?.label?.toLowerCase()?.includes("justification")
                ? "Justification Letter"
                : selectedDocType?.label}
              <span className={uploadStyles.uploadJustificationRequired}>
                *
              </span>
              <span className={uploadStyles.uploadJustificationBadge}>
                REQUIRED
              </span>
            </div>

            {availableDocumentTypes?.length > 1 && (
              <div style={{ marginBottom: 16, display: "flex", gap: 12 }}>
                {availableDocumentTypes.map((docType: any) => (
                  <Button
                    key={docType?.labelId}
                    type={
                      selectedDocTypeId === docType?.labelId
                        ? "primary"
                        : "default"
                    }
                    onClick={() => setSelectedDocTypeId(docType?.labelId)}
                    style={{
                      minWidth: 140,
                    }}
                  >
                    {docType?.label?.toLowerCase()?.includes("justification")
                      ? "Justification Letter"
                      : docType?.label}
                  </Button>
                ))}
              </div>
            )}

            {selectedDocuments?.length > 0 ? (
              <RightSideFilePreview
                documents={selectedDocuments}
                activeKey={activeKey}
                setUploadedDocuments={setUploadedDocuments}
                uploadedDocuments={uploadedDocuments}
              />
            ) : (
              <div className={uploadStyles.uploadJustificationBoxNoDocument}>
                No Document Uploaded
              </div>
            )}
          </div>
        </Col>

        <Col xs={24} sm={24} md={10}>
          <div className={styles.qcReviewReviewSection}>
            <NewExtensionOfStayFormEchs
              enhancementProcedure={[]}
              form={form}
              isProcedureSubmitted={isProcedureSubmitted}
            />
          </div>
        </Col>
      </Row>

      <div className={styles.qcReviewActionButtons}>
        <Space>
          {onCancel && (
            <Button size="large" onClick={onCancel}>
              Back
            </Button>
          )}

          {isProcedureSubmitted && (
            <Button
              size="large"
              onClick={onNext}
              style={{ background: "#00549e", color: "#fff" }}
            >
              Next
            </Button>
          )}

          {!isProcedureSubmitted && (
            <Button
              type="primary"
              size="large"
              loading={isSaving}
              // disabled={!file || fileList.length === 0}
              onClick={() => handleSubmit(false)}
              style={{ background: "#F1F5F9", color: "#00549e" }}
            >
              {"Save As Draft"}
            </Button>
          )}

          {auth?.role?.role !== "FO_STAFF" && !isProcedureSubmitted && (
            <Button
              type="primary"
              size="large"
              loading={isSubmitting}
              onClick={() => handleSubmit(true)}
              style={{ background: "#00549E", color: "white" }}
            >
              {"Submit to Portal"}
            </Button>
          )}
        </Space>
      </div>
    </div>
  );
};

export default QCReviewExtensionOfStay;
